import { createContext, useContext, useMemo } from "react";
import { useTag } from "hooks";

const TagContext = createContext({
    tagData: [],
    loader: null
});

export const TagProvider = ({ children }) => {
    const { tagData, loader,hasMore } = useTag();

    const value = useMemo(
        () => ({
            tagData,
            loader,
            hasMore
        }),
        [tagData, hasMore, loader]
    );

    return (
        <TagContext.Provider value={value}>
            {children}
        </TagContext.Provider>
    );
};

export const useTagContext = () => useContext(TagContext);
